// MahnungEingegangenCard — T2.16c.
//
// SEMANTIK-KORREKTUR (Bug A6, 2026-05-21): Quelle ist Tooltime-Snapshot
// top_5_overdue mit dunning_state — das sind UNSERE Forderungen im
// Mahnlauf gegen UNSERE KUNDEN (outgoing dunning), NICHT Lieferanten-
// Mahnungen gegen uns. Label entsprechend korrigiert. Echte Lieferanten-
// Mahnungen-Quelle (Email-Daemon / mahnung_eingegangen-DB) folgt
// separat, siehe TODO im Tile.

import { MahnungenEingegangenResponse, formatEUR } from "../../lib/api";

const STATUS_BADGE: Record<string, string> = {
  offen: "bg-rose-500/20 text-rose-200 border-rose-500/40",
  gezahlt: "bg-emerald-500/15 text-emerald-200 border-emerald-500/30",
  strittig: "bg-amber-500/20 text-amber-200 border-amber-500/40",
};

const STATUS_LABEL: Record<string, string> = {
  offen: "offen",
  gezahlt: "✓ gezahlt",
  strittig: "strittig",
};

interface Props {
  data?: MahnungenEingegangenResponse;
  loading?: boolean;
}

export default function MahnungEingegangenCard({ data, loading }: Props) {
  if (loading) {
    return <div className="text-xs text-slate-400">Lade Mahnungen …</div>;
  }
  const items = data?.items ?? [];
  if (items.length === 0) {
    return (
      <div className="text-xs text-slate-400">
        Keine eingegangenen Mahnungen erfasst.
      </div>
    );
  }
  return (
    <>
      <h3 className="text-[10px] font-medium text-slate-100 uppercase tracking-wide mb-2">
        Mahnstufen — eigene Forderungen ({data!.n_offen} offen ·{" "}
        <span className="tabular-nums text-rose-300">
          {formatEUR(data!.total_offen_eur)}
        </span>
        )
      </h3>
      <ul className="space-y-1.5">
        {items.slice(0, 3).map((m) => (
          <li
            key={m.id}
            className="flex items-baseline justify-between gap-2 text-xs"
          >
            <span className="flex-1 min-w-0">
              <span className="text-slate-100 font-medium truncate">
                {m.glaeubiger}
              </span>
              <span className="text-slate-500 ml-2">{m.firma_display}</span>
              {m.rechnungs_nr && (
                <span className="text-slate-600 ml-2 text-[10px] tabular-nums">
                  · {m.rechnungs_nr}
                </span>
              )}
            </span>
            {m.faellig_am && (
              <span className="text-[10px] tabular-nums text-slate-400">
                {m.faellig_am}
              </span>
            )}
            <span className="tabular-nums text-rose-300 shrink-0 font-semibold">
              −{formatEUR(m.betrag_eur)}
            </span>
            <span
              className={`shrink-0 text-[10px] px-1.5 py-0.5 rounded border ${STATUS_BADGE[m.status] ?? STATUS_BADGE.offen}`}
            >
              {STATUS_LABEL[m.status] ?? m.status}
            </span>
          </li>
        ))}
        {items.length > 3 && (
          <li
            className="text-[11px] text-slate-400"
            title="Vollständige Liste im Drawer scrollbar"
          >
            Top 3 von {items.length} (n_offen: {data!.n_offen}) — Drawer scrollen für mehr
          </li>
        )}
      </ul>
    </>
  );
}
